import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faStar, faQrcode, faTools,  faBriefcaseMedical, 
  faIdCard, faChartPie, faStethoscope, faHeartbeat,
  faClock, faRunning, faTint, faThermometerHalf, 
  faLungs, faWeight, faCapsules, faPills, faBed, 
  faDeaf, faLungsVirus, faHeartPulse, faSyncAlt,
  faBaby,
  faBolt,
  faEarth,
  faListDots,
  faBuilding,
  faCow
} from '@fortawesome/free-solid-svg-icons';
import './Integra.css';
import integraimage from '../../assets/pageimages/Integra.webp';

function IntegraHome() {

  const LinkButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-2xl sm:text-2xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  return (
    <MainLayout>
      <div className="text-sm min-h-screen bg-gradient-to-r from-teal-500 via-green-500 to-blue-500 flex flex-col items-center py-8">
        <h2 className="text-4xl font-bold text-white text-center mb-4">Integra</h2>
        <img
          src={integraimage}
          alt="Integra"
          className="w-full h-auto max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl rounded-lg shadow-lg flex-wrap"
        />

        <div className="flex-grow p-4">
          <div className="grid grid-cols md:grid-cols-4 gap-4 p-4 bg-gray-800 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4">
            <LinkButton to="/integra-myqrlist" icon={faTools} label="Register Equipment / Device" />
            <LinkButton to="/integra-myqrlist" icon={faBuilding} label="Register Location" />
            <LinkButton to="/integra-myqrlist" icon={faListDots} label="Enroll Ownership" />
          </div>

          <div className="grid grid-cols md:grid-cols-4 gap-4 p-4 bg-purple-800 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4 mt-6">
            <LinkButton to="/integra-comingsoon" icon={faBolt} label="Energy Card" />
            <LinkButton to="/integra-comingsoon" icon={faSyncAlt} label="ThinkSwitch" />
            <LinkButton to="/integra-comingsoon" icon={faEarth} label="Sustainability Card" />
            <LinkButton to="/integra-comingsoon" icon={faBriefcaseMedical} label="ThinkCrease" />
          </div>

          <div className="grid grid-cols md:grid-cols-4 lg:grid-cols-6 gap-4 p-4 bg-lime-600 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4 mt-6">
            {/* <LinkButton to="/health-card" icon={faIdCard} label="ThinkHealthcard" /> */}
            {/* <LinkButton to="/health-card-vet" icon={faCow} label="ThinkVetHealthcard" /> */}

            {/* <LinkButton to="/integra-comingsoon" icon={faChartPie} label="ThinkPatient Dashboard" />
            <LinkButton to="/integra-comingsoon" icon={faStethoscope} label="Healthcare Providers" />
            <LinkButton to="/integra-comingsoon" icon={faHeartbeat} label="Wellness Dashboard" /> */}
            <LinkButton to="/integra-viewdata" icon={faBaby} label="ThinkDiapers" />
            <LinkButton to="/integra-viewdata" icon={faClock} label="ThinkWatches" />
            <LinkButton to="/integra-viewdata" icon={faHeartbeat} label="BPM Machine" />
            <LinkButton to="/integra-viewdata" icon={faRunning} label="Fitness Tracker" />
            <LinkButton to="/integra-viewdata" icon={faTint} label="Glucose Monitors" />
            <LinkButton to="/integra-viewdata" icon={faThermometerHalf} label="Thermometer" />
            <LinkButton to="/integra-viewdata" icon={faLungs} label="Pulse Oximeter" />
            <LinkButton to="/integra-viewdata" icon={faHeartbeat} label="ECG/EKG" />
            <LinkButton to="/integra-viewdata" icon={faWeight} label="Scales" />
            <LinkButton to="/integra-viewdata" icon={faCapsules} label="Inhalers" />
            <LinkButton to="/integra-viewdata" icon={faPills} label="Pill Dispensers" />
            <LinkButton to="/integra-viewdata" icon={faBed} label="Sleep Monitors" />
            <LinkButton to="/integra-viewdata" icon={faDeaf} label="Hearing Aids" />
            <LinkButton to="/integra-viewdata" icon={faHeartbeat} label="RPM Kits" />
            <LinkButton to="/integra-viewdata" icon={faLungsVirus} label="Respiratory Devices" />
            <LinkButton to="/integra-viewdata" icon={faHeartPulse} label="ECG Patches" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default IntegraHome;
